import React, { Component } from 'react';
import TagManager from 'react-gtm-module';
import {getGranelPaymentHistory} from '../api.js';
import ContentBox from './ContentBox.js';
import ClientSelectGranel from './ClientSelectGranel';
import Paginator from './Paginator';
import PostFileDownloadDocument from './PostFileDownloadDocument';
export default class ServiciosGranelHistorialPagos extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchType: "days",
			searchPedido: "",
			filterDays: "30",
			checkers: [],
			page: 1,
			itemsPerPage: 3
		};
	}
	componentDidMount() {
		if(this.props.reloadServices) this.props.reloadServices();		
		if(this.props.selectedService) this.getList();
		this.sendCustomEventGTM({});
	}
	componentDidUpdate(prevProps, prevState) {
		const {checkers} = this.state;
		if(prevProps.selectedService !== this.props.selectedService) {
			this.getList(()=> this.sendCustomEventGTM({ trigger:"interaccion-seleccion-servicio" }));
		}
		if (prevState.checkers !== checkers && checkers.length && checkers.every(e=>e.status)) {
			this.setState({loading: false});
		}
	}

	sendCustomEventGTM({trigger="visita", metadata={}}){
		const event = "mis-servicios-granel-historial-pagos";
		const {client_address, client_city, client_cod, client_region_cod, client_street, client_id, client_number} = this.props.selectedService;
		const props = {client_address, client_city, client_cod, client_region_cod, client_street, client_id, client_number}; 

		TagManager.dataLayer({ 
			dataLayer:{ 
				event, 
				metadata: { trigger, ...props, ...metadata} 
			} 
		});
	}
	getList(cb) {
		this.setState({formErrors: null, loading: true, pagos: null, page: 1, pedidosMessage: "", checkers: []});
		getGranelPaymentHistory(this.props.selectedService.client_cod, (error, result) => {
			if(error) {
				if(cb) cb(error);
				this.setState({loading: false});
				return console.log(error);
			}
			if(result.status === "error") {
				if(cb) cb();
				return this.setState({loading: false, formErrors: result.errors});
			}
			if(result.status === "empty") {
				if(cb) cb();
				return this.setState({loading: false, pedidosMessage: result.message});
			}
			this.setState({pagos: result.data }, ()=> { 
				this.loadRenderedItems(this.state.page);
				if(cb)cb(); 
			});
		}, this.props.isEmpresa?"empresas":null);
	}
	changePage(page) {
		this.setState({page, loading: true}, ()=> {
			this.loadRenderedItems(page);
			this.sendCustomEventGTM({trigger:"cta-paginacion", metadata:{ page }})
		});
	}
	loadRenderedItems(page) {
		const { pagos, itemsPerPage } = this.state;
		const startPagination = (page - 1) * itemsPerPage;
		const endPagination = startPagination + itemsPerPage;
		const checkers = pagos.slice(startPagination,endPagination).map(({pdf_document:{pdf_number}})=> ({ pdf_id:pdf_number, status: false }));

		this.setState({checkers})
	}
	isChecked(id) {
		this.state.checkers.map((el, i)=>{
			if (el.pdf_id === id) {
				let array = [...this.state.checkers];
				array[i] = { ...array[i], status: true };
				this.setState({ checkers: array });
			}
		})
	}
	render() {
		return (
			<ContentBox loading={this.state.loading}>
				<div className="title-client-container clearfix">
					<h1>Historial de Pagos</h1>
					<div className="client-number">
						<ClientSelectGranel
							selected={this.props.selectedService}
							services={this.props.services}
							setSelectedService={this.props.setSelectedService}
							number_field={"client_cod"} />
					</div>
				</div>				
				<div className="table-container">
					<table className="table1">
						<thead>
							<tr>
								<td>Clase de documento</td>
								<td>Nro. Documento</td>
								<td>Fecha Emisión</td>
								<td>Fecha Vencimiento</td>
								<td>Valor</td>
								<td style={{maxWidth: '80px', padding: '0px'}}>Morosidad</td>
								<td>Fecha Cancelación</td>
								<td style={{maxWidth: '70px', padding: '0px'}}></td>
							</tr>
						</thead>
						<tbody>
							{!this.state.pagos?null:this.state.pagos.slice((this.state.page - 1)*this.state.itemsPerPage, (this.state.page - 1)*this.state.itemsPerPage + this.state.itemsPerPage).map((pago, i) => {
								return(
							<tr key={pago.doc_number}>
								<td>{pago.class_description}</td>
								<td>{pago.folio_number}</td>								
								<td>{pago.issue_date}</td>
								<td>{pago.expiration_date}</td>
								<td>${parseInt(pago.value).toLocaleString("de")}</td>
								<td>{parseInt(pago.late_payment) > 0?pago.late_payment:""}</td>
								<td>{pago.payment_date}</td>
								<td style={{maxWidth: '70px', paddingLeft: '0px'}}>
									{pago.pdf_document && 
										<PostFileDownloadDocument 
										createActionNotification={this.props.createActionNotification} 
										class_description={pago.pdf_document.class_description}
										client_cod={this.props.selectedService.client_cod}
										isEmpresa={this.props.isEmpresa?"empresas":null}
										doCheck={true}
										isChecked={this.isChecked.bind(this)}
										pdf_number={pago.pdf_document.pdf_number} 
										contentRender={() => 
											<div 
											className="linkA-container"
											onClick={()=> this.sendCustomEventGTM({trigger:"cta-descargar"})}>
												<a>Descargar Documento</a>
											</div>
										} />
									}
								</td>
							</tr>);

							})}
						</tbody>
					</table>
					{!this.state.pagos?<p>{this.state.pedidosMessage}</p>:null}
				</div>
				{this.state.pagos && this.state.pagos.length > this.state.itemsPerPage?<Paginator page={this.state.page} items={this.state.pagos?this.state.pagos.length:0} itemsPerPage={this.state.itemsPerPage} onPageChange={(page) => this.changePage(page)} />:null}					
			</ContentBox>
		);
	}
}
